import(/* webpackMode: "eager" */ "/opt/lumi/src/lumi/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lumi/src/lumi/src/components/lumi-rust/AddBookDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lumi/src/lumi/src/components/lumi-rust/DiscoverStarters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lumi/src/lumi/src/components/lumi-rust/LibraryAutoRefresh.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lumi/src/lumi/src/components/lumi-rust/LibraryBrowser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lumi/src/lumi/src/components/NavBar.tsx");
